import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { Logo } from "@/components/Layout";
import { ShieldCheck, CheckCircle, XCircle, SpinnerGap } from "@phosphor-icons/react";

export default function Attest() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/public/attest/${token}`).then(({ data }) => setInfo(data)).catch(() => setInfo({ valid: false }));
  }, [token]);

  const act = async (action) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/public/attest/${token}`, { action });
      setDone(data.status);
    } catch {
      setDone("error");
    } finally { setBusy(false); }
  };

  if (!info) return <div className="min-h-screen flex items-center justify-center text-zinc-400 font-mono text-sm">loading…</div>;

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-white grain">
      <div className="w-full max-w-md vf-fade-up" data-testid="attest-page">
        <div className="mb-6"><Logo /></div>
        {!info.valid ? (
          <div className="border border-zinc-200 p-6 rounded-lg text-center">
            <p className="text-sm text-zinc-600" data-testid="attest-invalid">This confirmation link is invalid, has expired, or was already used.</p>
          </div>
        ) : done ? (
          <div className="border border-zinc-200 p-6 rounded-lg text-center" data-testid="attest-result">
            {done === "attested" ? <CheckCircle size={40} weight="fill" className="text-emerald-600 mx-auto mb-2" />
              : done === "declined" ? <XCircle size={40} weight="fill" className="text-red-500 mx-auto mb-2" />
              : null}
            <p className="text-sm text-zinc-700">{done === "attested" ? "Thank you — your support has been recorded." : done === "declined" ? "You have declined. This has been recorded." : "Something went wrong."}</p>
          </div>
        ) : (
          <div className="border border-zinc-200 p-6 rounded-lg">
            <div className="inline-flex items-center gap-2 text-[#1F6FE5] mb-3"><ShieldCheck size={20} weight="fill" /><span className="text-xs uppercase tracking-widest font-bold">Nomination support</span></div>
            <p className="text-sm text-zinc-700 mb-4">
              <strong>{info.nominee_name}</strong> has named you as their <strong>{info.role}</strong> for
              {info.position ? <> <strong>{info.position}</strong> in</> : null} <strong>{info.election_title}</strong>{info.org ? <> ({info.org})</> : null}. Do you confirm your support?
            </p>
            <div className="flex gap-3">
              <button data-testid="attest-confirm" disabled={busy} onClick={() => act("confirm")}
                className="flex-1 h-11 bg-[#1F6FE5] text-white rounded-md font-semibold hover:bg-[#1552C9] transition-colors active:scale-95 flex items-center justify-center gap-2 disabled:opacity-60">
                {busy && <SpinnerGap size={16} className="animate-spin" />} Confirm
              </button>
              <button data-testid="attest-decline" disabled={busy} onClick={() => act("decline")}
                className="flex-1 h-11 border border-zinc-300 rounded-md font-semibold hover:border-black transition-colors active:scale-95">
                Decline
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
